module.exports = __webpack_public_path__ + "static/media/profile.b67413c6.svg";